import { isNil, isNull } from "lodash";
import { useEffect } from "react";
import { useTranslation } from "src/hooks";

import { MultiSelection } from "../../GeneralSelection";
import useQueryWalletVersion from "./hooks/useQueryWalletVersion";
import { getOne } from "./WalletVersionProvider";

type WalletVersionMultiSelectionProps = {
  value: string[];
  onChange: (value: string[]) => void;
  chainType: number | undefined;
  walletTypes?: (string | number)[];
};

function WalletVersionMultiSelection({
  value,
  onChange,
  chainType,
  walletTypes,
}: WalletVersionMultiSelectionProps) {
  const { tc } = useTranslation("common");

  const { walletVersions, rawResponseList } = useQueryWalletVersion({
    chainType,
    walletTypes,
  });

  useEffect(() => {
    onChange([]);
  }, [chainType, walletTypes]);

  const walletVersionNameFunc = (item: string) => {
    const target = getOne(rawResponseList, {
      chainType,
      walletVersion: item,
    });

    return `${item}${target?.description ? `(${target.description})` : ""}`;
  };

  return (
    <MultiSelection
      label={tc("phSelection", { fieldName: tc("version") })}
      value={value}
      onChange={(e) =>
        onChange(
          Array.isArray(e.target.value) ? e.target.value : [e.target.value],
        )
      }
      enumData={walletVersions}
      disabled={isNil(chainType)}
      nameFn={walletVersionNameFunc}
    />
  );
}

export default WalletVersionMultiSelection;
